import styled from "styled-components";

export const ContainerBanner = styled.div`
  display: flex;
  justify-content: center;
`;
